import { useEffect } from 'react'

import { type IUpdateFeedback, type IUnpublishedFeedback, type IFeedbacksDatesFilter } from '@/app/types/doctorsType'
import { Button, Modal } from '@/shared'

import { DatesRange } from './DatesRange/DatesRange'
import style from './FeedbacksModal.module.scss'
import { FeedbacksWrapper } from './FeedbacksWrapper/FeedbacksWrapper'

interface IProps {
    unpublishedFeedbacks: IUnpublishedFeedback[]
    isOpenModal: boolean
    feedbacksDatesFilter: IFeedbacksDatesFilter
    isFetchingFeedbacks: boolean
    onGetUnpublishedFeedbacks: () => void
    setIsOpenModal: (isOpenModal: boolean) => void
    onRemoveFeedback: (id: string, feedbackId: string, isPublished: boolean) => void
    onPublishFeedback: (dto: IUpdateFeedback) => void
    onSetFeedbackStartDatefilter: (startDate: string | null) => void
    onSetFeedbackEndDatefilter: (endDate: string | null) => void
}

export const FeedbacksModal = (props: IProps) => {
    const {
        unpublishedFeedbacks,
        isOpenModal,
        feedbacksDatesFilter,
        isFetchingFeedbacks,
        onGetUnpublishedFeedbacks,
        setIsOpenModal,
        onRemoveFeedback,
        onPublishFeedback,
        onSetFeedbackStartDatefilter,
        onSetFeedbackEndDatefilter
    } = props
    const { startDate, endDate } = feedbacksDatesFilter
    const onHandleCloseModal = () => setIsOpenModal(false)

    useEffect(() => {
        if (startDate && endDate) {
            onGetUnpublishedFeedbacks()
        }
    }, [startDate, endDate, onGetUnpublishedFeedbacks])

    const onClearFiltersHandler = () => {
        onSetFeedbackStartDatefilter(null)
        onSetFeedbackEndDatefilter(null)
        onGetUnpublishedFeedbacks()
    }

    return (
        <Modal show={isOpenModal} onClose={onHandleCloseModal} modalStyles={style.modalStyles}>
            <div className={style.container}>
                <div className={style.blockHeader}>
                    <span>Неопубликованные отзывы</span>
                </div>
                <div className={style.filters}>
                    <DatesRange
                        startDate={startDate}
                        onSetStartDate={onSetFeedbackStartDatefilter}
                        endDate={endDate}
                        onSetEndDate={onSetFeedbackEndDatefilter}
                    />
                    <Button className={style.clear} onClick={onClearFiltersHandler}>
                        Очистить
                    </Button>
                </div>
                <FeedbacksWrapper
                    unpublishedFeedbacks={unpublishedFeedbacks}
                    isFetchingFeedbacks={isFetchingFeedbacks}
                    onRemoveFeedback={onRemoveFeedback}
                    onPublishFeedback={onPublishFeedback}
                />
            </div>
        </Modal>
    )
}
